export enum ExportTypeEnum {
    Pdf = "application/pdf",
    Excel = "application/vnd.ms-excel",
    Zip = "zip",
    Csv = "text/csv"
}
